/**
 * linkify — transforma URLs em texto plano em <a> clicáveis.
 *
 * Escapa TODO o HTML da entrada antes de injetar os anchors, então o retorno é
 * seguro pra usar com v-html (não há risco de XSS a partir do conteúdo da
 * mensagem). Reconhece http(s):// e também www.dominio.
 *
 * Uso:
 *   import linkify from '@/services/linkify';
 *   // template: <span v-html="linkify(item.conteudo)"></span>
 */

const ESCAPE_MAP = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
};

function escapeHtml(str) {
  return String(str).replace(/[&<>"']/g, (c) => ESCAPE_MAP[c]);
}

// http(s)://... ou www... até o próximo espaço/quebra/< .
const URL_RE = /(\bhttps?:\/\/[^\s<]+|\bwww\.[^\s<]+)/gi;
// Pontuação que costuma vir colada no fim da URL mas não faz parte dela.
const TRAILING_RE = /[)\].,;:!?'"]+$/;

export default function linkify(texto) {
  if (texto === null || texto === undefined) return '';
  const raw = String(texto);
  let out = '';
  let lastIndex = 0;

  raw.replace(URL_RE, (match, _grupo, offset) => {
    // Trecho de texto comum antes do link — escapado.
    out += escapeHtml(raw.slice(lastIndex, offset));

    // Separa pontuação final (ex.: "veja https://x.com." → link sem o ponto).
    let url = match;
    let trailing = '';
    const m = url.match(TRAILING_RE);
    if (m) {
      trailing = url.slice(url.length - m[0].length);
      url = url.slice(0, url.length - m[0].length);
    }

    const href = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    out += `<a href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer nofollow">${escapeHtml(url)}</a>`;
    out += escapeHtml(trailing);

    lastIndex = offset + match.length;
    return match;
  });

  out += escapeHtml(raw.slice(lastIndex));
  return out;
}
